export default "/images/448374c25504bea5f4a2e884bab3fbeb.avif";